const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    addToCartCTA: document.querySelector('.addtocart-cta'),
    addToCartContainer: document.querySelector('.addtocart-container'),
    customGiftOption: document.querySelector('#custom_denomination')
  };

  class TemplateProductJS {
    constructor() {
      if(selectors.addToCartCTA) this.stickyATC();
      this.manageCustomGiftCard();
    }

    manageCustomGiftCard(){
      if(!selectors.customGiftOption) return;
    
      selectors.customGiftOption.checked = false;
      const productForm = selectors.customGiftOption.closest('form');
      const denominationSelect = document.querySelector('.variant_selector[name="options[Denominations]"]');
      const customAmountParent = document.querySelector('[data-customAmount]');

      selectors.customGiftOption.addEventListener('change', (_event)=>{
        if(selectors.customGiftOption.checked == true){
          denominationSelect.disabled = true;
          let customInput = `<input type="number" name="properties[_custom_amount]" value="1" min="1">`;
          customAmountParent.querySelector('.custom-input').innerHTML = customInput;
          setTimeout(() => {
            productForm.querySelector('input[name="id"]').value = selectors.customGiftOption.dataset.varid;
          }, 1000);          
        }else{
          denominationSelect.disabled = false;
          customAmountParent.querySelector('.custom-input').innerHTML = '';
          productForm.querySelector('[name="id"]').value = window.globalVariables.product.currentVariant;
        }
      });
    }   

    stickyATC(){
      window.onscroll = ()=> {
        let elementTop = selectors.addToCartContainer.getBoundingClientRect().top;
        let classAdded = selectors.addToCartCTA.classList.contains('sticky-btn');
        if(elementTop < 0 && !classAdded){
          selectors.addToCartCTA.classList.add('sticky-btn');
        }else if(elementTop >= 0 && classAdded){
          selectors.addToCartCTA.classList.remove('sticky-btn');
        }
      }
    } 
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();